export const useFamilySwitchMember = () => {
  const profile = useProfileStore();

  const context = useContextStore();

  const { path, meta } = useRoute();

  const locked = meta.locked != null ? meta.locked : false;

  const _getParentLoginToken = (parentMemberId) => {
    if (!profile.familyMembers) return null;
    const member = profile.familyMembers.find(
      (member) => member.memberId === parentMemberId
    );
    if (member) return member.loginToken;
    return null;
  };

  const storage = useNomadStorage(
    'family',
    {
      parentLoginToken: '',
      memberLoginToken: '',
    },
    'family'
  );

  const redirectTo = computed(() => {
    let redirect = locked ? '/' : path;
    redirect = redirect.indexOf('/famille') === 0 ? '/' : redirect;
    return redirect;
  });

  const switchToMember = (member: FamilyMember) => {
    storage.value.memberLoginToken = member.loginToken;
    if (member.status === 'parent') {
      window.location.href = `/switch?continue=/`;
    } else {
      window.location.href = `/switch?continue=${redirectTo.value}`;
    }
  };

  const switchToParent = () => {
    storage.value.memberLoginToken = null;
    window.location.href = `/switch?continue=/`;
  };

  const isAvailable = computed<boolean>(() => {
    return (
      storage.value.parentLoginToken != null &&
      storage.value.parentLoginToken.length > 0
    );
  });

  const isSwitchableBackToParent = computed(
    () => isAvailable.value && !profile.isParent
  );

  const isSwitchableProfile = computed(() => {
    return profile.isParent || isSwitchableBackToParent.value;
  });

  const canSwitchToMember = (member: FamilyMember) => {
    if (!member) return false;
    if (!profile.isParent && !isAvailable.value) return false;
    if (member.memberId === context.memberId) return false;

    return (
      isAvailable.value && member.loginToken && member.shareResultsWithFamily
    );
  };

  const loginToken = computed(() =>
    storage.value.memberLoginToken
      ? storage.value.memberLoginToken
      : storage.value.parentLoginToken
  );

  const clear = () => {
    storage.value = {
      memberLoginToken: null,
      parentLoginToken: null,
    };
  };

  if (profile.isParent) {
    storage.value.parentLoginToken = _getParentLoginToken(context.memberId);
  }

  return {
    switchToMember,
    switchToParent,
    canSwitchToMember,
    loginToken,
    isAvailable,
    isSwitchableBackToParent,
    isSwitchableProfile,
    clear,
  };
};
